import { createContext, useCallback, useState, useSyncExternalStore } from "react"
import API from "services/api"
import _ from "lodash"
import toast from "react-hot-toast"

export const CDesainIndustriContext = createContext({})

const CDesainIndustriProvider = (props) => {
	const [contactDI, setContactDI] = useState([])
	const [cDIbyPage, setCDIByPage] = useState([])
	const [detailCDI, setDetailCDI] = useState({})
	const [error, setIsError] = useState(null)
	const [searchContact, setSearchContact] = useState("")
	const [filterContact, setFilterContact] = useState("")
	const [dataFilterDropdown, setDataFilterDropdown] = useState(null)

	const [detailContact, setDetailContact] = useState(null)

	const [openEdit, setOpenEdit] = useState(false)
	// open chnge contact
	const [open, setOpen] = useState(false)
	const [openChange, setOpenChange] = useState(false)
	const [selected, setSelected] = useState(null)

	// Contacts
	const getListCindustri = useCallback(async (params) => {
		await API.getListCindustri(params)
			.then((res) => {
				const { data } = res
				setContactDI(data)
			})
			.catch((err) => {
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const getCindustribyPage = (params) => {
		API.getCindustribyPage(params)
			.then((res) => {
				const { data } = res
				setCDIByPage(data)
			})
			.catch((err) => {
				setIsError(err.message || "An error occurred")
			})
	}

	const getCindustri = useCallback(async (id, params) => {
		return await API.getCindustri(id, params)
			.then((res) => {
				const { data } = res

				setDetailCDI(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const putCindustri = useCallback(async (id, body) => {
		return API.putCindustri(id, body)
			.then((res) => {
				const { data } = res

				setDetailCDI(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				setIsError(err.message || "An error occurred")
			})
	}, [])

	const handleSearchContact = async (e) => {
		if (e) {
			if (dataFilterDropdown !== null) {
				const searchQuery = e?.target?.value.toString().toLowerCase()
				setSearchContact(searchQuery)
				const filtered = ["companyName", "contactPerson", "name", "phone", "fax", "email", "category", "address"].map((x, i) => {
					return dataFilterDropdown.filter((el) => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1
						}
						return false
					})
				})
				const dataset = _.maxBy(filtered, function (o) {
					return o.length
				})
				setFilterContact(dataset)
			} else {
				const searchQuery = e?.target?.value.toString().toLowerCase()
				setSearchContact(searchQuery)
				const filtered = ["companyName", "contactPerson", "name", "phone", "fax", "email", "category", "address"].map((x, i) => {
					return contactDI.filter((el) => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1
						}
						return false
					})
				})
				const dataset = _.maxBy(filtered, function (o) {
					return o.length
				})
				setFilterContact(dataset)
			}
		} else {
			setSearchContact("")
			setFilterContact(contactDI)
		}
	}

	return (
		<CDesainIndustriContext.Provider
			value={{
				error,
				setIsError,

				contactDI,
				cDIbyPage,
				detailCDI,

				setContactDI,
				setCDIByPage,
				setDetailCDI,

				getListCindustri,
				getCindustribyPage,
				getCindustri,

				searchContact,
				filterContact,
				dataFilterDropdown,
				handleSearchContact,

				openEdit,
				setOpenEdit,
				selected,
				setSelected,

				putCindustri,

				open,
				setOpen,

				detailContact,
				setDetailContact
			}}
			{...props}
		/>
	)
}

export default CDesainIndustriProvider
